module.exports = __webpack_public_path__ + "img/PT33.25043e43.png";